import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { HTTP_OPTIONS } from 'app/_helper/header.config';
import { CatalogueDetails, CatalogueModel } from 'app/_models/catalogue.model';
import { FormModel } from 'app/_models/form.model';
import { RecordSearchModel } from 'app/_models/recordsearch.model';
import { environment } from 'environments/environment';
import moment from 'moment';
import { BehaviorSubject, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CatalogueService {
  firstLoad: boolean;
  formJob: boolean = false;
  fromCatalogue: boolean = false;
  catalogues = signal<FormModel[]>(null);
  calogueUpdated = signal<boolean>(null);
  downloadCatalogue = signal<boolean>(null);
  private _items: BehaviorSubject<FormModel[] | null> = new BehaviorSubject(null);
  private _catalogueFilteredViewItems = signal(null);
  private timeOut: any;
  constructor(private _http: HttpClient) {
    this.timeOut = moment.now();
    this.firstLoad = true;
  }
  // public get catalogues(): FormModel[] {
  //   return this._items.value;
  // }
  catalogueFilteredViewItems(): any {
    return this._catalogueFilteredViewItems();
  }
  public set setCatalogueFilteredViewItems(catObj) {
    this._catalogueFilteredViewItems.set(catObj);
  }
  async getCatalogueItems(userFormId: any) {
    return await lastValueFrom(this._http.get<CatalogueModel>(`${environment.BASEURLAPI}${environment.CATALOGUEUNIQUECOLUMNURL}/` + userFormId));
  }
  async purgeCatalogueItem(userFormId: any, catalogueItemValue: any, itemId: any) {
    return await lastValueFrom(this._http.post(`${environment.BASEURLAPI}${environment.CATALOGUEURL}/${userFormId}/purge/${catalogueItemValue}?itemId=${itemId}`, 0));
  }
  async getJobCatalogueItems(catalogueId: any) {
    return await lastValueFrom(this._http.get<CatalogueModel>(`${environment.BASEURLAPI}${environment.CATALOGUEURL}/` + catalogueId));
  }

  async getCatalogueDetailsByUserFormId(userFormId: any) {
    return await lastValueFrom(this._http.get<CatalogueDetails>(`${environment.BASEURLAPI}${environment.CATALOGUEDETAILSBYUSERFORMID}/` + userFormId));
  }
  async getCatalogueDetailsCatalogueId(catalogueId: any) {
    return await lastValueFrom(this._http.get<CatalogueDetails>(`${environment.BASEURLAPI}${environment.CATALOGUEDETAILSBYCATALOGUEID}/` + catalogueId));
  }
  public async getCatalogues(): Promise<FormModel[]> {
    var spanshot = moment.now();

    var difference = (spanshot - this.timeOut) / (1000 * 60); //minutes

    if (difference > 5 || this.firstLoad) {
      this.firstLoad = false;
      let cat = await this.getCataloguesFromAPI();
      this.catalogues.set(cat);
      return cat;
    } else {
      return this.catalogues();
    }
  }
  private async getCataloguesFromAPI() {
    return await lastValueFrom(this._http.get<FormModel[]>(`${environment.BASEURLAPI}${environment.CATALOGUEURL}`));
    // .pipe(
    //   tap((response: any) => {
    //     this._items.next(response);
    //   })
    // );
  }

  //Get completed records based on the filters
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public async getCompletedRecords(formId: any, filters: RecordSearchModel) {
    return await lastValueFrom(this._http.post<any[]>(`${environment.BASEURLAPI}${environment.CATALOGUEURL}${'/'}${formId}${'/'}${environment.FORMRECORDURL}`, JSON.stringify(filters), HTTP_OPTIONS));
  }
  public async updateCatalogeItems(data: any): Promise<any> {
    var formData: any = new FormData();
    formData.append('name', data.name);
    // formData.append('CatalogueId', data.catalogueId);
    formData.append('UserFormId', data.userFormId);
    formData.append('file', data.file);
    return await lastValueFrom(this._http.put(`${environment.BASEURLAPI}${environment.UPLOADCATALOGUE}`, formData, { responseType: 'text' }));
  }
}
